;
define("itemssearcher_item.tpl", function(){});

